var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.33337V13.3334H2.66667V9.33337H0V14.6667C0 15.0203 0.140476 15.3595 0.390524 15.6095C0.640573 15.8596 0.979711 16 1.33333 16H14.6667C15.0203 16 15.3594 15.8596 15.6095 15.6095C15.8595 15.3595 16 15.0203 16 14.6667V9.33337H13.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 10.6667H9.33337V5.33333H12.6667L8.00004 0L3.33337 5.33333H6.66671V10.6667Z",
    fill: "white"
  })));
}

export default SvgUpload;